import $ from 'jquery';
import scrollTo from '@spinnwerk/scroll-helper/lib/scroll-to';
import 'jquery-pjax';


var PJAX = function(options) {
    this.linkSelector = options.linkSelector;
    this.classes = options.classes;

    this.DOM = {};

    this.wasHomeEntryPoint = false;
    this.onHomePage = false;
    this.homeTitle = document.title;

    this.isBackButton = false;

    this.languageURLs = ['/'];

    this.scrollPositionY = 0;

    this.onReInit = options.onReInit;
    this.onAfterInit = options.onAfterInit;

    this.init();
};

PJAX.prototype = {
    init: function() {
        $(document).on('keypress', this.onKeyPress.bind(this));
        $('.pjax-container').on('click', this.onBackgroundClick.bind(this));

        $('.pjax-container *').on('click', function(e) {
            e.stopPropagation();
        });

        if ($('body').hasClass('home')) {
            this.wasHomeEntryPoint = true;
            this.onHomePage = true;

            this.initDOM();
            this.setLanguageURLs();
            this.initEvents();
            this.initPJAX();
        }
    },

    initDOM: function() {
        this.DOM.$container = $('.' + this.classes.container);
    },

    initEvents: function() {
        $(document).off('pjax:start').on('pjax:start', this.onStart.bind(this));
        $(document).off('pjax:success').on('pjax:success', this.onSuccess.bind(this));
        $(document).off('pjax:error').on('pjax:error', this.onError.bind(this));
        $(document).off('pjax:click').on('pjax:click', this.onClick.bind(this));
        $(document).off('pjax:popstate').on('pjax:popstate', this.onBack.bind(this));

        // remove pjax header to enable W3C total cache caching
        $(document).off('pjax:beforeSend').on('pjax:beforeSend', function(xhr, options, settings) {
            settings.url = settings.url.replace('?_pjax=.pjax-content', '');
        });

        $(this.linkSelector).off('click').on('click', this.onLinkClick.bind(this));

        this.onReInit();
        this.onAfterInit();
    },

    initCloseButton: function() {
        $('.' + this.classes.closeButton).off('click').on('click', this.onCloseButtonClick.bind(this));
    },

    initPJAX: function() {
        $(document).pjax('a', '.' + this.classes.content, {
            fragment: '.' + this.classes.fragment,
            timeout: 10000
        });
    },

    setLanguageURLs: function() {
        var $languageOptions = $('.' + this.classes.languageSwitcher).find('option');

        for (let i = 0; i < $languageOptions.length; i++) {
            this.languageURLs.push('/' + $($languageOptions[i]).val().replace(location.origin, ''));
        }
    },

    onBackgroundClick: function() {
        this.close();
    },

    onKeyPress: function(e) {
        if (e.keyCode === 27) {
            this.close();
            return;
        }
    },

    onClick: function(/*e*/) {
        // nothing to do for now
    },

    onLinkClick: function(e) {
        if (this.onHomePage && this.languageURLs.indexOf($(e.currentTarget).attr('href')) !== -1) {
            this.onHomePage = true;
            scrollTo({top: 0});
            $('html').css({ overflow: 'auto' });
            $('.page-detail-wrapper').removeAttr('style');

            e.preventDefault();
            return false;
        }

        if (!this.onHomePage && ($(e.currentTarget).attr('href')[0] === '#' || $(e.currentTarget).attr('href')[1] === '#')) {
            this.close();
        }

        if (this.wasHomeEntryPoint && !this.onHomePage) {
            if ($(e.currentTarget).hasClass(this.classes.closeButton) || this.languageURLs.indexOf($(e.currentTarget).attr('href')) !== -1) {
                this.close();

                return false;
            }
        }

        if (this.scrollPositionY === 0) {
            this.scrollPositionY = (window.pageYOffset != null) ? window.pageYOffset : (document.documentElement.scrollTop != null) ? document.documentElement.scrollTop : document.body.scrollTop;
        }
    },

    onStart: function(e) {
        if (this.languageURLs.indexOf(e.currentTarget.URL.replace(location.origin, '')) !== -1) {
            this.close();
            this.onHomePage = true;
            return;
        } else {
            this.onHomePage = false;
        }

        $('html').css({ overflow: 'hidden' });
        $('.nav .is-visible').removeClass('is-visible');

        $('.page-detail-wrapper').css({ top: this.scrollPositionY * -1 });
        $('.page-detail--wrapper').html('');

        this.DOM.$container.addClass(this.classes.containerVisible);

        if (!this.isBackButton) {
            this.DOM.$container.addClass(this.classes.containerLoading);
        }

        this.isBackButton = false;
    },

    onSuccess: function() {
        this.DOM.$container.removeClass(this.classes.containerLoading);

        this.initEvents();
    },

    onError: function() {
        this.onHomePage = true;

        $('html').css({ overflow: 'auto' });
        $('.page-detail-wrapper').removeAttr('style');

        this.DOM.$container.removeClass(this.classes.containerVisible);
        this.DOM.$container.removeClass(this.classes.containerLoading);
    },

    onBack: function() {
        this.isBackButton = true;

        this.DOM.$container.removeClass(this.classes.containerLoading);

        this.initEvents();
    },

    onCloseButtonClick: function(e) {
        e.preventDefault();

        this.close();
    },

    close: function() {
        if (!this.onHomePage) {
            this.closing = true;
            if (!this.wasHomeEntryPoint) {
                location.href = window.icl_vars.icl_home;
                return;
            }
        }

        setTimeout((function() {
            this.closing = false;
        }).bind(this), 500);

        this.onHomePage = true;

        this.DOM.$container.removeClass(this.classes.containerVisible);
        $('.' + this.classes.content).html('');

        $('html').css({ overflow: 'auto' });
        $('.page-detail-wrapper').removeAttr('style');

        window.scrollTo(0, this.scrollPositionY);
        this.scrollPositionY = 0;
        document.title = this.homeTitle;
        history.replaceState({}, this.homeTitle, window.icl_vars.icl_home);
    }
};

export default PJAX;



// WEBPACK FOOTER //
// ./resources/assets/js/lib/pjax.js